import type { SerializedReseller } from '@enmon/commons/lib/tools';
import { gql } from '@apollo/client';

export const GET_RESELLERS_DATA = gql`
  query getResellersData($sort: [String], $limit: Int, $start: Int) {
    resellers(pagination: { limit: $limit, start: $start }, sort: $sort) {
      data {
        id
        attributes {
          name
          trial_establishments_pool_size
          trial_meters_online_pool_size
          trial_meters_offline_pool_size
          enmon_customer_id
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
`;

export interface ResellersVariables {
  limit: number;
  sort: string[];
  start: number;
}

export type ResellersDataItem = Pick<
  SerializedReseller,
  | 'id'
  | 'name'
  | 'trial_establishments_pool_size'
  | 'trial_meters_offline_pool_size'
  | 'trial_meters_online_pool_size'
  | 'enmon_customer_id'
>;

export interface ResellersData {
  resellers: {
    data: ResellersDataItem[];
    meta: { pagination: { total: number } };
  };
}
